import { downgradeInjectable } from '@angular/upgrade/static';
import { module } from 'angular';

import { default as historyDeprecatedServiceName, HistoryDeprecatedService } from './core/history-deprecated.service';
import { HistoryService } from './core/history.service';
import { default as importCsvPopinName, ImportCsvPopin } from './popin/import-csv-popin/import-csv-popin.component.ajs';
import {
  default as intercationRecordPopinName,
  InteractionRecordPopin,
} from './popin/interaction-record-popin/interaction-record-popin.component.ajs';

export default module('contact.history', [])
  .service(historyDeprecatedServiceName, HistoryDeprecatedService)
  .factory('historyService', downgradeInjectable(HistoryService as any))
  .component(importCsvPopinName, new ImportCsvPopin())
  .component(intercationRecordPopinName, new InteractionRecordPopin()).name;
